import { KeyValueItem, KeyValueStore } from './types';

export const transformKeyValueStoreForApi = (store: KeyValueStore): any => store;

export const transformKeyValueStore = (response: any): KeyValueStore => response;

export const transformKeyValueItemForApi = (item: KeyValueItem): any => item;

export const transformKeyValueItem = (response: any): KeyValueItem => response;
